<template>
    <div id="app">
        <transition name="el-fade-in-linear">
            <router-view/>
        </transition>
    </div>
</template>

<script>
import {
  loadBrandOwnerProduct,
  loadBrandProductTree,
  loadCountry, loadDict,
  loadProduct,
  loadSubBrand, loadSysSettLang,
  loadSysSupportLang,
  saveUserInfo,
} from "./js/common";

export default {
  created() {
    if(window.sessionStorage.getItem('login-user-info')) {
      // 保存用户信息
      saveUserInfo(this);
      // 请求国家列表
      loadCountry(this);
      //系统设置语言
      loadSysSettLang(this);

      loadSysSupportLang(this);
      loadProduct(this)
      loadBrandProductTree(this);
      loadSubBrand(this, this.$store.state.userInfo.brandOwnerCode);
      loadDict(this, 'INGREDIENTS_UNIT', 'ADD_RECIPE_UNIT');
      loadDict(this, 'HOT_WIND_MODE', 'ADD_HOST_WIND_MODE');
      loadBrandOwnerProduct(this, this.$store.state.userInfo.brandOwnerCode, true);
      this.$store.dispatch('LOAD_DEV_MODES');
    }
  }
}
</script>

<style lang="scss">

    * {
        font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    }

    html, body, #app {
        height: 100%;
        position: relative;
        overflow: hidden;
    }

    .action-el-link{
        margin-right: 12px;
    }

    .action-el-link:last-child{
        margin-right: 0;
    }

    .cf-dialog .el-dialog__body{
        padding-top: 12px;
    }



    input::-webkit-inner-spin-button {
      -webkit-appearance: none !important;
    }

    input::-webkit-outer-spin-button {
      -webkit-appearance: none !important;
    }

    input[type="number"] {
      -moz-appearance: textfield;
    }


</style>
